// action
export const getTicket = (state, val) => {
  state.tickets = val
}

export const getTicketDetail = (state, val) => {
  state.ticket = val
}

export const getTicketChat = (state, val) => {
  state.chats = val
}

export const getTicketAttachment = (state, val) => {
  state.attachments = val
}
